import { isServiceWorkerSupported } from '#pplx/frontend/workers/service-worker/utils/isServiceWorkerSupported.js';
import { CACHE_NAME_PREFIXES, METADATA, } from '#pplx/frontend/workers/service-worker/utils/metadata.js';
const CACHE_PREFIXES = CACHE_NAME_PREFIXES;
const SW_HTML_CACHE_NAMES = CACHE_PREFIXES.map((prefix) => [prefix, METADATA.cacheName.html, METADATA.cacheName.suffix].join('-'));
const SW_RUNTIME_CACHE_NAMES = CACHE_PREFIXES.map((prefix) => [prefix, METADATA.cacheName.runtime, METADATA.cacheName.suffix].join('-'));
/**
 * Clears the service worker HTML document cache.
 */
export async function clearServiceWorkerHtmlCache() {
    if (isServiceWorkerSupported()) {
        await Promise.all(SW_HTML_CACHE_NAMES.map((cacheName) => caches.delete(cacheName)));
        return;
    }
}
/**
 * Clears the service worker runtime cache.
 */
export async function clearServiceWorkerRuntimeCache() {
    if (isServiceWorkerSupported()) {
        await Promise.all([...SW_HTML_CACHE_NAMES, ...SW_RUNTIME_CACHE_NAMES].map((cacheName) => caches.delete(cacheName)));
        return;
    }
}
//# sourceMappingURL=clearServiceWorkerRuntimeCache.js.map